import React from "react";
import "./index.scss";
import vectorImage from "../../../src/assets/img/Vector.png";

const errorComponent = (props) => {
  return (
    <div className="wrapper">
      <div>
        <img src={vectorImage} alt="attention" />
      </div>
      <div className="att-tit">{props.title}</div>
      <div className="att-des">{props.description}</div>
    </div>
  );
};

export default errorComponent;
